import { QueryFunctionContext, useQuery } from "react-query";
import { axios } from "./AxiosInstance";

export const getAttemptedQuestionPaperById = async (id: string) => {
  const { data } = await axios.get(`/attempted-question-papers/${id}`);
  return data;
};

// export const getSubmittedAttemptsByStudentAndPaper = async ({
//   studentId,
//   paperId,
// }: {
//   studentId: string;
//   paperId: string;
// }) => {
//   const { data } = await axios.post(
//     "/api/attempt-review/students",
//     {},
//     {
//       params: {
//         student: studentId,
//         test: paperId,
//       },
//     }
//   );

//   return data.data?.[0];
// };




export const getMySubmittedQuestionPapers = async () => {
  const { data } = await axios.get("/attempt-review/student");
  return data || [];
};

export const getStaffSubmittedQuestionPapers = async () => {
  const { data } = await axios.get("/attempt-review/staff");
  return data || [];
};


export interface UpdateAdminReviewPayload {
  questionResult: any[];
  reviewedBy: string;
  reviewDate: string;
  adminComment?: string;        
  isResultPending?: boolean;    
  scoreObtained?: number;       
  totalMarks?: number;          
}

export const updateAdminReview = async (
  attemptId: string,
  payload: UpdateAdminReviewPayload
) => {
  const response = await axios.put(`/attempt-review/review/${attemptId}`, payload);
  return response.data;
};



export const saveAdminReview = async ({
  attemptId,
  questionResult,
}: {
  attemptId: string;
  questionResult: any[];
}) => {
  const { data } = await axios.patch("/attempt-review/admin/save", {
    attemptId,
    questionResult,
  });
  return data.data; // return updated attempt
};


export const fetchStudentAttemptById = async (id: string) => {
  const { data } = await axios.get(`/attemptedQuestionPaper/${id}`);
  return data;
};